export default "__VITE_ASSET__265906e2__"